import api from '@api';
import { call, put, takeEvery } from 'redux-saga/effects';
import {
    getBillOfMaterialsDetailFetchSuccess,
    getBillOfMaterialsDetailFetchFailure,
    createBillOfMaterialsDetailFetchSuccess,
    createBillOfMaterialsDetailFetchFailure,
    updateBillOfMaterialsDetailFetchSuccess,
    updateBillOfMaterialsDetailFetchFailure,
} from './reducer';
import { BillOfMaterialsDetailResType } from 'src/types/billOfMaterialsDetail';
import translate from '@translate';
import { BillOfMaterialsType } from 'src/types/billOfMaterials';

const getBillOfMaterialsDetailFetchRequest = async (idBillOfMaterials: string) => {
    const res = await api('get', `api/secure/bill-of-materials/${idBillOfMaterials}`);
    return res.data;
};

function* getBillOfMaterialsDetailFetch(action: { type: string; payload: string }) {
    try {
        const response: BillOfMaterialsDetailResType = yield call((): any =>
            getBillOfMaterialsDetailFetchRequest(action.payload)
        );
        yield put(getBillOfMaterialsDetailFetchSuccess(response));
    } catch (error) {
        yield put(getBillOfMaterialsDetailFetchFailure({ error }));
    }
}

export function* getBillOfMaterialsDetailFetchWatch() {
    yield takeEvery('billOfMaterialsDetail/getBillOfMaterialsDetailFetch', getBillOfMaterialsDetailFetch);
}

const createBillOfMaterialsDetailFetchRequest = async (data: BillOfMaterialsType) => {
    const res = await api('post', 'api/secure/bill-of-materials', data);
    return res.data;
};

function* createBillOfMaterialsDetailFetch(action: { type: string; payload: BillOfMaterialsType }) {
    try {
        const response: BillOfMaterialsDetailResType = yield call((): any =>
            createBillOfMaterialsDetailFetchRequest(action.payload)
        );
        yield put(
            createBillOfMaterialsDetailFetchSuccess({
                ...response,
                messageSuccess: { title: translate('billsOfMaterials.message.billOfMaterialsCreated') },
            })
        );
    } catch (error) {
        yield put(createBillOfMaterialsDetailFetchFailure({ error }));
    }
}

export function* createBillOfMaterialsDetailFetchWatch() {
    yield takeEvery('billOfMaterialsDetail/createBillOfMaterialsDetailFetch', createBillOfMaterialsDetailFetch);
}

const updateBillOfMaterialsDetailFetchRequest = async (params: {
    idBillOfMaterials: string;
    data: BillOfMaterialsType;
}) => {
    const res = await api('put', `api/secure/bill-of-materials/${params.idBillOfMaterials}`, params.data);
    return res.data;
};

function* updateBillOfMaterialsDetailFetch(action: {
    type: string;
    payload: { idBillOfMaterials: string; data: BillOfMaterialsType };
}) {
    try {
        const response: BillOfMaterialsDetailResType = yield call((): any =>
            updateBillOfMaterialsDetailFetchRequest(action.payload)
        );
        yield put(
            updateBillOfMaterialsDetailFetchSuccess({
                ...response,
                messageSuccess: { title: translate('billsOfMaterials.message.billOfMaterialsUpdated') },
            })
        );
    } catch (error) {
        yield put(updateBillOfMaterialsDetailFetchFailure({ error }));
    }
}

export function* updateBillOfMaterialsDetailFetchWatch() {
    yield takeEvery('billOfMaterialsDetail/updateBillOfMaterialsDetailFetch', updateBillOfMaterialsDetailFetch);
}
